module.exports = __webpack_public_path__ + "img/duble-arrow.2707e196.svg";